import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mitt from 'mitt'
import VueGtag from 'vue-gtag'

require('@/assets/styles/style.css')
require('@/assets/styles/styles_from_django.css')

const emitter = mitt();
const app = createApp(App).use(store).use(router);
app.config.globalProperties.emitter = emitter;
app.config.devtools = true;
app.config.productionTip = false;
// Vue.config.devtools = true
window.$ = window.jQuery = require('jquery');

app.use(VueGtag, {
  config: { id: 'G-19420E55NL' }, // Replace with your actual Google Analytics tracking code
})
app.mount('#app');
